export default __webpack_public_path__ + "static/media/white-paper.19ced794.svg";